import React from "react";
import {
  Col,
  Row,
  Spinner,
  Card,
  CardBody,
  CardImg,
  CardTitle,
  CardText,
} from "reactstrap"; // Reactstrap components
import { Image } from "../../../../AbstractElements";

const ProfileBrandMatchesEmptyState = ({
  readyToMatch,
  match_status,
  isBrand,
  selectedTab,
  searchTxt,
}) => {
  console.log(selectedTab)
  return (
    <Row
      style={{
        height: "50vh",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      {readyToMatch && match_status ? (
        // Case 1
        <Col className="text-center">
          <Card>
            <CardBody>
              <CardTitle
                style={{ fontSize: "20px", fontWeight: 500, color: "#7D7D7D" }}
              >
                It seems this {isBrand ? "Brand" : "Retailer"} is currently in
                the matching queue.
              </CardTitle>
              <img
                src="/loader.gif"
                alt="Loader"
                style={{ height: "200px", objectFit: "contain" }}
              />
            </CardBody>
          </Card>
        </Col>
      ) : searchTxt ? (
        // Case 2
        <Col className="text-center">
          <Card>
            <CardBody>
              <CardTitle tag="h5" style={{ fontSize: "22px", fontWeight: 600 }}>
                No results found
              </CardTitle>
              <CardText
                style={{
                  color: "#7D7D7D",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                There's nothing matching "<strong>{searchTxt}</strong>
                ".
                <br />
                Try adjusting your keywords or explore related brands.
              </CardText>
            </CardBody>
          </Card>
        </Col>
      ) : !readyToMatch ? (
        // Case 3
        <Col className="text-center">
          <Card>
            <CardBody>
              <CardTitle tag="h5" style={{ fontSize: "22px", fontWeight: 600 }}>
                {selectedTab === "Similar Retailers" ? "Coming Soon" : "We are getting useful insights"}
              </CardTitle>
              <CardText
                style={{
                  color: "#7D7D7D",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                {selectedTab === "Similar Retailers" ? "Smilar Retailers will be avaliable soon" : "AI engine is working and grabbing exciting data"}
              </CardText>
              <img
                src="/loader.gif"
                alt="Loader"
                style={{ height: "200px", objectFit: "contain" }}
              />
            </CardBody>
          </Card>
        </Col>
      ) : (
        // Fallback
        <Col className="text-center">
          <Card>
            <CardBody>
              <CardTitle
                style={{ fontSize: "20px", fontWeight: 500, color: "#7D7D7D" }}
              >
                It seems this {isBrand ? "Brand" : "Retailer"} is currently in
                the matching queue.
              </CardTitle>
              <img
                src="/loader.gif"
                alt="Loader"
                style={{ height: "200px", objectFit: "contain" }}
              />
            </CardBody>
          </Card>
        </Col>
      )}
    </Row>
  );
};

export default ProfileBrandMatchesEmptyState;
